import React from 'react'
import { pure } from 'recompose'
import { Route, Link, withRouter } from 'react-router-dom'
import { CardHeader } from 'material-ui/Card'
import Paper from 'material-ui/Paper'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import Autorenew from 'material-ui/svg-icons/action/autorenew'
import Room from 'material-ui/svg-icons/action/room'
import Divider from 'material-ui/Divider'
import Chip from 'material-ui/Chip'
import FontIcon from 'material-ui/FontIcon'
import { List, ListItem } from 'material-ui/List'
import shrinked from './shrinked'
import { themeColors } from '../styles/theme'
import { AFFIDABILITA_ICON_NAME } from '../styles/icons'

const styles = {
  paper: {
    display: 'inline-block',
    float: 'left',
    //margin: '16px 32px 16px 0'
    margin: 0,
    width: '250px',
  },
  titleStyle: {
    color: themeColors.positive,
    fontWeight: 'bold',
    fontSize: 18,
  },
  rightIcon: {
    textAlign: 'center',
    lineHeight: '24px',
  },
  menuItemStyle: {
    lineHeight: '25px',
    width: '250px',
    minHeight: 25,
    fontSize: 14,
    color: themeColors.energized,
  },
  menuIcon: {
    margin: 1,
    left: 7,
    marginLeft: 20,
    fill: themeColors.energized,
    color: themeColors.energized,
  },
  listItem: {},
  listItemActive: {
    backgroundColor: themeColors.lightBackground,
  },
  countChip: {
    top: 12,
    backgroundColor: 'transparent',
  },
}

const MeSideMenu = ({ user, counts }) => (
  <Paper style={styles.paper}>
    <CardHeader
      title={user.username}
      titleStyle={styles.titleStyle}
      subtitle={user.nome}
      // avatar="/img/user.jpg"
      style={{ paddingBottom: 6 }}
    />
    <Menu menuItemStyle={styles.menuItemStyle}>
      <MenuItem
        primaryText={`${Number(user.affidabilita * 100).toFixed()} %`}
        leftIcon={
          <FontIcon className="material-icons" style={styles.menuIcon}>
            {AFFIDABILITA_ICON_NAME}
          </FontIcon>
        }
      />
      <MenuItem
        primaryText={`${user.transazioni} scambi`}
        leftIcon={<Autorenew style={styles.menuIcon} />}
      />
      <MenuItem
        primaryText={`${user.district || ''}`}
        leftIcon={<Room style={styles.menuIcon} />}
      />
    </Menu>
    <Divider style={{ marginTop: 15 }} />
    <List>

      <Route
        path={`/me/items/owned`}
        exact={true}
        children={({ match }) => (
          <ListItem
            style={match ? styles.listItemActive : styles.listItem}
            rightAvatar={
              <Chip style={styles.countChip} labelColor={themeColors.energized}>
                {counts.ownedItems}
              </Chip>
            }
            containerElement={<Link to={`/me/items/owned`} />}
            primaryText="Possiedo"
          />
        )}
      />

      <Route
        path={`/me/items/wanted`}
        children={({ match }) => (
          <ListItem
            style={match ? styles.listItemActive : styles.listItem}
            rightAvatar={
              <Chip style={styles.countChip} labelColor={themeColors.energized}>
                {counts.wantedItems}
              </Chip>
            }
            containerElement={<Link to={`/me/items/wanted`} />}
            primaryText="Voglio"
          />
        )}
      />

      <Route
        path={`/me/items/can-get`}
        exact={true}
        children={({ match }) => (
          <ListItem
            style={match ? styles.listItemActive : styles.listItem}
            rightAvatar={
              <Chip style={styles.countChip} labelColor={themeColors.energized}>
                {counts.itemsICanGet}
              </Chip>
            }
            containerElement={<Link to={`/me/items/can-get`} />}
            primaryText="Posso avere"
          />
        )}
      />

      <Route
        path={`/me/swaps`}
        children={({ match }) => (
          <ListItem
            style={match ? styles.listItemActive : styles.listItem}
            rightAvatar={
              <Chip style={styles.countChip} labelColor={themeColors.energized}>
                {counts.newSwaps}
              </Chip>
            }
            containerElement={<Link to={`/me/swaps`} />}
            primaryText="Proposte"
          />
        )}
      />
      <ListItem
        rightAvatar={
          <Chip style={styles.countChip} labelColor={themeColors.energized}>
            {counts.ecoins}
          </Chip>
        }
        primaryText="eCoin"
      />
    </List>
  </Paper>
)

export default withRouter(
  shrinked(pure(MeSideMenu), 'AccountSideMenuContainer')
)



// WEBPACK FOOTER //
// ./src/common/MeSideMenu.js